export default "Le suramortissement fiscal permet aux entreprises de déduire 40% supplémentaires sur leurs investissements en équipements de production d'énergie renouvelable et d'efficacité énergétique.";
